import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { AudienceQuestion } from './questions';
import './base.scss';
import { AppSyncMockProvider } from './__mocks__/mock-provider'
import QuestionNotification from './notification';

if (process.env.GIT_VERSION) {
  console.log(`StagePilot Live version ${process.env.GIT_VERSION}`);
}
const Wrapper = function() {
  const [mockNotification, setMockNotification] = useState({status:'HIDDEN',message:""})
  return (
    <AppSyncMockProvider>
      <div className='Mock_Notification'>
      <QuestionNotification notification={mockNotification} setNotification={setMockNotification}/>
      </div>
      <AudienceQuestion setNotification={setMockNotification}/>
    </AppSyncMockProvider>
  )
}
const harnessElement = document.getElementById('audience-questions-harness');

if (harnessElement) {
  ReactDOM.render(<Wrapper/>,harnessElement)
}